<div class="modal-container mt-3 d-flex flex-column">
    <h4>Pay Credit Card Bill</h4>

    <div class="field d-flex align-items-center mb-3 mt-3" *ngIf="payBillForm.controls.used">
        <p class="account-fund-field-label">Used Limit</p>
        <div class="account-fund-field-input">
            <app-value-field [editMode]="false" [value]="payBillForm.controls.used.value"> </app-value-field>
        </div>
    </div>
    <div class="field d-flex align-items-center mb-3" *ngIf="payBillForm.controls.available">
        <p class="account-fund-field-label">Available Credit Limit</p>
        <div class="account-fund-field-input">
            <app-value-field [editMode]="false" [value]="payBillForm.controls.available.value"> </app-value-field>
        </div>
    </div>
    <div class="field d-flex align-items-center mb-3" *ngIf="payBillForm.controls.total">
        <p class="account-fund-field-label">Total Limit</p>
        <div class="account-fund-field-input">
            <app-value-field [editMode]="false" [value]="payBillForm.controls.total.value"> </app-value-field>
        </div>
    </div>
    <div class="field d-flex align-items-center mb-3" *ngIf="payBillForm.controls.amount">
        <p class="account-fund-field-label">Amount to be Paid</p>
        <div class="account-fund-field-input">
            <app-value-field [editMode]="true">
                <app-value-field-input
                    [controlDisplayName]="'Amount to be loaded'"
                    [control]="payBillForm.controls.amount"
                    appValueField="editField"
                    inputType="number"
                    placeholder="Enter amount"
                ></app-value-field-input>
            </app-value-field>
            <div class="validation-message" *ngIf="payBillForm.errors">
                <span *ngIf="payBillForm.errors?.['zeroLimit']">
                  You have no outstanding balance to pay.
                </span>
                <span *ngIf="payBillForm.errors?.['minAmount']">
                  Amount should be at least 1.
                </span>
                <span *ngIf="payBillForm.errors?.['maxLimit']">
                  Amount cannot exceed Used Limit ({{ payBillForm.get('used')?.value }}).
                </span>
              </div>
        </div>
    </div>
    <div class="field d-flex align-items-center mb-3" *ngIf="payBillForm.controls.currency">
        <p class="account-fund-field-label">Currency</p>
        <div class="account-fund-field-input">
            <app-value-field [editMode]="true">
                <app-value-field-select [control]="payBillForm.controls.currency" appValueField="editField" controlDisplayName="Currency" placeholder="Select currency">
                    <ng-template *ngFor="let currency of currencies" [appValueFieldOption]="currency">
                        <span>{{ currency }}</span>
                    </ng-template>
                </app-value-field-select>
            </app-value-field>
        </div>
    </div>

    <div class="field d-flex align-items-center mb-3" *ngIf="payBillForm.controls.note">
        <p class="account-fund-field-label">Comments</p>
        <div class="account-fund-field-input">
            <app-value-field [editMode]="true">
                <app-value-field-input
                    [controlDisplayName]="'Comments'"
                    [control]="payBillForm.controls.note"
                    appValueField="editField"
                    placeholder="Enter comments"
                ></app-value-field-input>
            </app-value-field>
        </div>
    </div>

    <div class="footer d-flex justify-content-end align-items-center">
        <button
            class="rounded-pill me-2 pay-bill-btn"
            [class.button-spinner]="isLoading"
            [ngClass]="{ 'btn-primary': payBillForm.valid && !isLoading }"
            [disabled]="payBillForm.invalid || isLoading"
            (click)="loadFunds()"
            mat-flat-button
        >
            Pay Now
        </button>
        <button mat-raised-button class="btn-secondary rounded-pill" (click)="closeModal()">Cancel</button>
    </div>
</div>
